import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ExcelValidateUtil, ValidateRule } from '@shared/utils/excel-validate-util';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-files-submit-validate',
  templateUrl: './files-submit-validate.component.html',
  styleUrls: ['./files-submit-validate.component.scss']
})
export class FilesSubmitValidateComponent {
  @Input() title: string;
  @Input() templateName: string;
  @Input() fileTitle: string;
  @Input() validateRule: ValidateRule;
  @Input() okTitle = 'Submit';

  @Output() downloadTemplate = new EventEmitter();
  @Output() upload = new EventEmitter();
  @Output() downloadErrorExcel = new EventEmitter();
  @Output() submit = new EventEmitter();

  dialogForm: UntypedFormGroup;

  isValidateSuccess: boolean;
  errorFile: any;

  assetPath = environment.assetPath;

  constructor(private bsModalRef: BsModalRef) {
    this.createFormDialog();
  }

  createFormDialog() {
    this.dialogForm = new FormGroup({
      file: new FormControl(null, [Validators.required])
    });
  }

  onDownloadTemplate(): void {
    this.downloadTemplate.emit();
  }

  clearFile() {
    this.isValidateSuccess = false;
    this.errorFile = undefined;
    this.dialogForm.get('file').reset();
  }

  importItems(e: any) {
    this.dialogForm.get('file').setValue(e.target.files[0]);
    ExcelValidateUtil.validate(this.dialogForm.value.file, this.validateRule).subscribe(res => {
      if (res.errorMessage) {
        this.dialogForm.get('file').setErrors(res);
      } else {
        this.upload.emit(this.dialogForm.value.file);
      }
    });
  }

  onDownloadTemplateError(): void {
    this.downloadErrorExcel.emit();
  }

  onSubmit(): void {
    this.submit.emit();
  }

  closeModal(): void {
    this.isValidateSuccess = false;
    this.errorFile = undefined;
    this.dialogForm.get('file').reset();
    this.bsModalRef.hide();
  }

  setErrorMessage(message: any, isErrorFile: boolean) {
    this.dialogForm.get('file').setErrors(message);
    this.errorFile = isErrorFile;
  }
}
